import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronTop"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0001 5.58569L20.7072 14.2928L19.293 15.707L12.0001 8.41412L4.70718 15.707L3.29297 14.2928L12.0001 5.58569Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTop;
